import { render, staticRenderFns } from "./menu-permission.vue?vue&type=template&id=b8a92ac8&scoped=true&"
import script from "./menu-permission.vue?vue&type=script&lang=js&"
export * from "./menu-permission.vue?vue&type=script&lang=js&"
import style0 from "./menu-permission.vue?vue&type=style&index=0&id=b8a92ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a92ac8",
  null
  
)

export default component.exports